<patron-responsive-table
  [items]="notifications"
  (onRowClicked)="onRowClicked($event)"
  [findOptions]="findOptions"
  [loading]="loading"
  [mobileSortable]="false"
  #table
  [headerTemplate]="header"
  [bodyTemplate]="body"
  customEmptyMessage="Nenhuma notificação">
  <ng-template #header>
    @if (!isFromHeader) {
      <tr>
        <th style="width: 200px">Data</th>
        <th>Título</th>
        <th>{{ sent ? 'Destinatário' : 'Remetente' }}</th>
        <!-- <th>Mensagem</th> -->
      </tr>
    }
  </ng-template>
  <ng-template #body let-item>
    <tr [class.bg-secondary]="item.read" (click)="onRowClicked(item)">
      @if (!isFromHeader) {
        <td style="width: 200px">{{ item.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
      }
      <td>{{ item.title }}</td>
      @if (!isFromHeader) {
        <td>{{ sent ? item.receiver_description : item.sender_description }}</td>
      }
      <!-- <td *ngIf="!isFromHeader">{{ item.message | truncate: [100] }}</td> -->
    </tr>
  </ng-template>
</patron-responsive-table>
